import React from "react";
import { getTextWhenPointsExpire, getTextWhenPointsExpireExample } from "../../../utils/getPointMessages";

import "./section-when-expire.scss";

const SectionWhenExpire = props => {
    const {isLogin} = props

    return (
        <div className={"f-section-when-expire-container" + (isLogin ? ' f-back-login' : '')}>
            <div className={"f-section-when-expire-container-wrap" + (isLogin ? ' f-reverse-login' : '')}>
                <div className="f-image-when-expire" />
                <div className="f-info-container">
                    <div className="f-info-container-title">
                        <h2>¿Cuándo se vencen los puntos?</h2>
                    </div>
                    <div className="f-info-container-description">
                        <p>
                            {getTextWhenPointsExpire(process.env.LOCALE)}
                        </p>
                        <br />
                        <p>
                            <b>Ejemplo:</b> {getTextWhenPointsExpireExample(process.env.LOCALE)}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SectionWhenExpire;